import type { PaginatorInfo } from 'graphql-models';
import type { Factory } from './helpers';

export const MOCK_PAGINATOR_INFO_MORE: PaginatorInfo = {
  count: 30,
  currentPage: 1,
  firstItem: 1,
  hasMorePages: true,
  lastItem: 30,
  lastPage: 7,
  perPage: 30,
  total: 199,
};

export const MOCK_PAGINATOR_INFO_EMPTY: PaginatorInfo = {
  count: 0,
  currentPage: 1,
  firstItem: null,
  hasMorePages: false,
  lastItem: null,
  lastPage: 1,
  perPage: 30,
  total: 0,
};

type Paginator<Data> = { data: Data[]; paginatorInfo: PaginatorInfo };

export const emptyPaginatedData = <Data>(overrides?: PaginatorInfo): Paginator<Data> => ({
  data: [],
  paginatorInfo: emptyPaginatorInfoFactory(overrides),
});

export const paginatedData = <Data>(data: Data[], overrides?: PaginatorInfo): Paginator<Data> => ({
  data,
  paginatorInfo: paginatorInfoFactory({
    count: data.length,
    total: data.length,
    ...overrides,
  }),
});

export const slicedPaginatedData = <Data>(
  data: Data[],
  { page, first }: { page: number; first: number },
  overrides?: PaginatorInfo,
): Paginator<Data> => {
  const firstItem = (page - 1) * first + 1;
  const lastItem = Math.min(page * first, data.length);
  const slicedData = data.slice(firstItem - 1, lastItem);

  return {
    data: slicedData,
    paginatorInfo: paginatorInfoFactory({
      ...overrides,
      firstItem,
      lastItem,
      hasMorePages: page * first < data.length,
      count: slicedData.length,
      total: data.length,
    }),
  };
};

export const paginatorInfoFactory: Factory<PaginatorInfo> = (overrides) => ({
  ...MOCK_PAGINATOR_INFO_MORE,
  ...overrides,
});

export const emptyPaginatorInfoFactory: Factory<PaginatorInfo> = (overrides) => ({
  ...MOCK_PAGINATOR_INFO_EMPTY,
  ...overrides,
});
